module.exports = __webpack_public_path__ + "static/media/quality-02.975ad82a.jpg";